export function ArticleCardSkeleton() {
  return (
    <div className="tw-bg-search-grey/10 tw-w-full tw-h-[250px] tw-flex tw-flex-row tw-space-x-4 tw-animate-pulse"></div>
  )
};